import { useLazyQuery } from "@apollo/client/react"; import { Checkbox, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { DateInput } from '../../../components/dateInput/DateInput';
import { CustomButton } from '../../../components/customButton/CustomButton';
import SearchIcon from '@mui/icons-material/Search';

import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { GET_CONEXIONES_PENDIENTE_FACTURAR, adaptConexionesPendienteFacturarArray } from '../../../data/graphQL/queries/GenerarMinuta/getConexionesPendienteFacturar';
import moment from 'moment';
import toast from 'react-hot-toast';
import { CompareDates } from '../../../utils/helpers';

export const GenerarMinutaGrillaFilters = ({
  delegaciones,
  filters,
  handleChangeFilters,
  setConexionesPendientesFacturar,
  setConexionesPendientesLoading,
  setDelegaciones,
  refetchGrilla,
  setRefetchGrilla,
  generateRunning,
  periodoActivo
}) => {
  const storageId = sessionStorage.getItem('idUsuario');
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [datosOriginal, setDatosOriginal] = useState([]);
  const [textFilter, setTextFilter] = useState(null);
  const txtFiltro = useRef(null);

  useEffect(() => {
    if (!delegacionesLoading)
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    if (localStorage.getItem('generarMinutaGrillaFilters') != null && !getConexionesPendientesLoading)
      handleSearch();
  }, []);

  const [getDelegaciones, { data: dataDelegaciones, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    setDelegaciones(adaptDelegacionArray(dataDelegaciones));
  }, [dataDelegaciones]);

  useEffect(() => {
    if (delegaciones != null && !delegacionOrigenLoading)
      getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId, 10) } });
  }, [delegaciones]);

  const [getDelegacionOrigen, { data: delegacionOrigenData, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      setDelegacionOrigen(deleg);
      handleChangeFilters('idDelegacion', localStorage.getItem('generarMinutaGrillaFilters') != null && filters.idDelegacion > 0 ? filters.idDelegacion : deleg);
    }
  }, [delegacionOrigenData]);

  useEffect(() => {
    if (refetchGrilla && !getConexionesPendientesLoading)
      handleSearch();
  }, [refetchGrilla]);

  useEffect(() => {
    if (periodoActivo != null && !getConexionesPendientesLoading)
      handleSearch();
  }, [periodoActivo]);

  const [getConexionesPendientesFacturar, { data: dataConexionesPendientes, loading: getConexionesPendientesLoading }] = useLazyQuery(GET_CONEXIONES_PENDIENTE_FACTURAR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataConexionesPendientes) return;
    setConexionesPendientesLoading(false);
    const regs = adaptConexionesPendienteFacturarArray(dataConexionesPendientes.conexionesPendienteFacturar);
    setDatosOriginal(regs);
    setConexionesPendientesFacturar(regs);
    setRefetchGrilla(false);
  }, [dataConexionesPendientes]);

  const validateFilters = () => {
    if (!filters.mesesAnteriores) {
      if (filters.fechaDesde == "" || filters.fechaHasta == "") {
        toast.error("La Fecha desde y la Fecha hasta son obligatorias si no busca sobre meses anteriores.");
        return false;
      }

      if (CompareDates(filters.fechaDesde, filters.fechaHasta) === 1) {
        toast.error("La Fecha desde no puede ser posterior a la Fecha hasta.");
        return false;
      }
    } else {
      // a pesar de no tomar en cuenta las fechas al consultar "meses anteriores", si alguna
      // de las fechas está le seteo al valor de la otra, si ambas están vacías seteo fecha actual
      if (filters.fechaDesde == "" && filters.fechaHasta != "") {
        handleChangeFilters('fechaDesde', filters.fechaHasta);
      } else if (filters.fechaDesde != "" && filters.fechaHasta == "") {
        handleChangeFilters('fechaHasta', filters.fechaDesde);
      } else if (filters.fechaDesde == "" && filters.fechaHasta == "") {
        handleChangeFilters('fechaDesde', moment().format("YYYY-MM-DD"));
        handleChangeFilters('fechaHasta', moment().format("YYYY-MM-DD"));
      }
    }

    return true;
  };

  const handleSearch = () => {
    if (periodoActivo != null && !getConexionesPendientesLoading && validateFilters()) {
      // limpio la grilla
      setDatosOriginal([]);
      setConexionesPendientesFacturar([]);

      setConexionesPendientesLoading(true);
      getConexionesPendientesFacturar({
        variables: {
          filter: {
            fechaDesde: filters.fechaDesde != "" ? filters.fechaDesde : filters.fechaHasta != "" ? filters.fechaHasta : moment().format("YYYY-MM-DD"),
            fechaHasta: filters.fechaHasta != "" ? filters.fechaHasta : filters.fechaDesde != "" ? filters.fechaDesde : moment().format("YYYY-MM-DD"),
            idDelegacion: filters.idDelegacion,
            mesesAnteriores: filters.mesesAnteriores,
            idCliente: "",
            idPaciente: ""
          }
        }
      });
    }
  };

  const handleTextFilter = () => {
    const inputBuscar = textFilter?.toString().toUpperCase();

    if (inputBuscar?.length >= 2) {
      setConexionesPendientesFacturar(datosOriginal?.filter((datoOriginal) => {
        const hcBuscar = datoOriginal.idPaciente.toString();
        const nombrePacienteBuscar = datoOriginal.paciente.toUpperCase();
        const clienteBuscar = datoOriginal.cliente.toUpperCase();
        const clienteSapBuscar = datoOriginal.codClienteSAP.toString();
        const programaBuscar = datoOriginal.tipoModulo.toUpperCase();
        const contratoBuscar = datoOriginal.idEvaluacion.toString();

        return (
          hcBuscar.includes(inputBuscar) ||
          nombrePacienteBuscar.includes(inputBuscar) ||
          clienteBuscar.includes(inputBuscar) ||
          clienteSapBuscar.includes(inputBuscar) ||
          programaBuscar.includes(inputBuscar) ||
          contratoBuscar.includes(inputBuscar));

      }));
    } else {
      setConexionesPendientesFacturar(datosOriginal);
    }
  };

  const handleChangeFecha = (name, value) => {
    handleChangeFilters(name, moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : '');
  };

  const handleCheck = (e) => {
    handleChangeFilters('mesesAnteriores', e.target.checked);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4, xl: 1.8, }}>
          <DateInput
            label="Fecha Desde"
            value={filters?.fechaDesde}
            onChange={(value) => handleChangeFecha("fechaDesde", value)}
            name="fechaDesde" />

        </Grid>
        <Grid size={{ xs: 12, md: 4, xl: 1.8, }}>
          <DateInput
            label="Fecha Hasta"
            value={filters?.fechaHasta}
            onChange={(value) => handleChangeFecha("fechaHasta", value)}
            name="fechaHasta" />

        </Grid>
        <Grid size={{ xs: 12, md: 4, xl: 2, }} key="ctlFilterMeses">
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                id="mesesAnteriores"
                onChange={handleCheck}
                checked={filters?.mesesAnteriores} />

            }
            labelPlacement='end'
            label="Meses anteriores" />

        </Grid>
        <Grid size={{ xs: 12, md: 4, xl: 2.5, }}>
          <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
            <InputLabel id="select-delegacion">Delegación</InputLabel>
            <Select
              labelId="select-delegacion"
              options={delegaciones}
              label='Delegación'
              onChange={(e) => {
                handleChangeFilters('idDelegacion', e.target.value);
              }}
              value={filters?.idDelegacion}
              name='idDelegacion'>

              {delegaciones && delegaciones.map((delegacion) => {
                return delegacion.id > 0 && <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12, md: 4, xl: 2.7 }}>
          <TextField
            label="Filtrar"
            name="txtFiltro"
            size="small"
            type="text"
            variant="outlined"
            value={textFilter ?? ''}
            onChange={(e) => setTextFilter(e.target.value)}
            onKeyUp={handleTextFilter}
            sx={{ backgroundColor: 'white' }}
            InputProps={{
              endAdornment:
                <InputAdornment position="end">
                  <SearchIcon
                    onClick={handleTextFilter}
                    sx={{ cursor: 'pointer' }} />

                </InputAdornment>

            }} />

        </Grid>
        <Grid size={{ xs: 12, md: 4, xl: 1.2, }} sx={{ textAlign: 'right' }}>
          <CustomButton
            variant='contained'
            className='margin-right'
            onClick={handleSearch}
            size='small'
            isLoading={getConexionesPendientesLoading}
            disabled={periodoActivo == null || periodoActivo <= 0 || generateRunning}>

            Buscar
          </CustomButton>
        </Grid>
      </Grid>
    </>);

};